module.exports = __webpack_public_path__ + "static/media/tiburón.81e91c69.png";